import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  statusCell: {
    width: '20%'
  },
  actionsCell: {
    minWidth: '240px'
  },
  storiesCount: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px'
  },
  storyTitleTooltip: {
    display: 'block'
  }
});
